import { Navigate } from "react-router-dom";
import { isAuthenticated } from "../api/session";

export default function PublicOnlyRoute({ children }) {
  return isAuthenticated() ? <Navigate to="/dashboard" replace /> : children;
}
